import React, { useState, useEffect } from "react";

export default function LandingScreen({ onGetStarted }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div style={{ fontFamily: "'DM Sans', system-ui, sans-serif", background: "#0A0A0A", minHeight: "100vh", color: "#fff" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Serif+Display:ital@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 0; }

        .nav { position: fixed; top: 0; left: 0; right: 0; z-index: 100; padding: 20px 40px; display: flex; justify-content: space-between; align-items: center; transition: background 0.3s; }
        .nav.scrolled { background: rgba(10,10,10,0.95); backdrop-filter: blur(10px); border-bottom: 1px solid rgba(255,255,255,0.06); }
        .nav-logo { font-family: 'DM Serif Display', serif; font-size: 28px; color: #fff; letter-spacing: -1px; }
        .nav-btn { padding: 10px 24px; border-radius: 100px; border: 1.5px solid rgba(255,255,255,0.2); background: none; color: #fff; font-family: 'DM Sans', sans-serif; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
        .nav-btn:hover { background: rgba(255,255,255,0.1); border-color: rgba(255,255,255,0.4); }
        .nav-btn-primary { background: #fff; color: #0A0A0A; border-color: #fff; }
        .nav-btn-primary:hover { background: rgba(255,255,255,0.9); }

        .hero { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 120px 40px 80px; position: relative; overflow: hidden; }
        .hero-bg { position: absolute; inset: 0; background: radial-gradient(ellipse at 50% 60%, rgba(29,185,84,0.08) 0%, transparent 70%); }
        .hero-tag { display: inline-flex; align-items: center; gap: 8px; background: rgba(29,185,84,0.1); border: 1px solid rgba(29,185,84,0.3); border-radius: 100px; padding: 6px 16px; font-size: 13px; color: #1DB954; font-weight: 600; margin-bottom: 32px; position: relative; z-index: 1; }
        .hero-title { font-family: 'DM Serif Display', serif; font-size: clamp(56px, 8vw, 96px); color: #fff; letter-spacing: -3px; line-height: 0.95; margin-bottom: 24px; position: relative; z-index: 1; }
        .hero-title span { color: #1DB954; font-style: italic; }
        .hero-sub { font-size: clamp(16px, 2vw, 20px); color: rgba(255,255,255,0.5); max-width: 560px; line-height: 1.6; margin-bottom: 48px; font-weight: 400; position: relative; z-index: 1; }
        .hero-actions { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; position: relative; z-index: 1; }
        .btn-primary { padding: 16px 36px; border-radius: 100px; border: none; background: #fff; color: #0A0A0A; font-family: 'DM Sans', sans-serif; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
        .btn-primary:hover { background: rgba(255,255,255,0.9); transform: translateY(-1px); }
        .btn-secondary { padding: 16px 36px; border-radius: 100px; border: 1.5px solid rgba(255,255,255,0.2); background: none; color: #fff; font-family: 'DM Sans', sans-serif; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
        .btn-secondary:hover { border-color: rgba(255,255,255,0.5); background: rgba(255,255,255,0.05); }

        .features { padding: 120px 40px; max-width: 1200px; margin: 0 auto; }
        .section-tag { font-size: 12px; font-weight: 700; letter-spacing: 2px; text-transform: uppercase; color: #1DB954; margin-bottom: 16px; }
        .section-title { font-family: 'DM Serif Display', serif; font-size: clamp(36px, 5vw, 56px); color: #fff; letter-spacing: -2px; line-height: 1.1; margin-bottom: 16px; }
        .section-sub { font-size: 18px; color: rgba(255,255,255,0.4); max-width: 480px; line-height: 1.6; margin-bottom: 64px; }
        .features-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 24px; }
        .feature-card { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 32px; transition: all 0.2s; }
        .feature-card:hover { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.15); transform: translateY(-2px); }
        .feature-icon { font-size: 32px; margin-bottom: 16px; }
        .feature-title { font-size: 18px; font-weight: 700; color: #fff; margin-bottom: 8px; letter-spacing: -0.3px; }
        .feature-desc { font-size: 14px; color: rgba(255,255,255,0.4); line-height: 1.6; }

        .how-it-works { padding: 120px 40px; background: rgba(255,255,255,0.02); }
        .steps { max-width: 800px; margin: 0 auto; display: flex; flex-direction: column; gap: 0; }
        .step { display: flex; gap: 32px; align-items: flex-start; padding: 40px 0; border-bottom: 1px solid rgba(255,255,255,0.06); }
        .step:last-child { border-bottom: none; }
        .step-num { width: 48px; height: 48px; border-radius: 50%; background: rgba(29,185,84,0.1); border: 1px solid rgba(29,185,84,0.3); display: flex; align-items: center; justify-content: center; font-size: 18px; font-weight: 700; color: #1DB954; flex-shrink: 0; }
        .step-title { font-size: 22px; font-weight: 700; color: #fff; letter-spacing: -0.5px; margin-bottom: 8px; }
        .step-desc { font-size: 15px; color: rgba(255,255,255,0.4); line-height: 1.6; }

        .social { padding: 120px 40px; max-width: 1200px; margin: 0 auto; }
        .social-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
        .social-card { background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 20px; padding: 40px; }
        .social-card.accent { background: rgba(29,185,84,0.08); border-color: rgba(29,185,84,0.2); }

        .cta { padding: 120px 40px; text-align: center; }
        .cta-box { max-width: 640px; margin: 0 auto; background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 32px; padding: 64px 48px; }
        .cta-title { font-family: 'DM Serif Display', serif; font-size: clamp(36px, 5vw, 52px); color: #fff; letter-spacing: -2px; margin-bottom: 16px; }
        .cta-sub { font-size: 17px; color: rgba(255,255,255,0.4); margin-bottom: 40px; line-height: 1.6; }

        .footer { padding: 40px; border-top: 1px solid rgba(255,255,255,0.06); display: flex; justify-content: space-between; align-items: center; }
        .footer-logo { font-family: 'DM Serif Display', serif; font-size: 22px; color: rgba(255,255,255,0.4); }
        .footer-text { font-size: 13px; color: rgba(255,255,255,0.2); }

        @media (max-width: 768px) {
          .nav { padding: 16px 20px; }
          .hero { padding: 100px 20px 60px; }
          .features, .how-it-works, .social, .cta { padding: 80px 20px; }
          .social-grid { grid-template-columns: 1fr; }
          .step { flex-direction: column; gap: 16px; }
          .footer { flex-direction: column; gap: 12px; text-align: center; }
        }
      `}</style>

      {/* NAV */}
      <nav className={`nav ${scrolled ? "scrolled" : ""}`}>
        <div className="nav-logo">tapped</div>
        <div style={{ display: "flex", gap: 12 }}>
          <button className="nav-btn" onClick={onGetStarted}>Sign In</button>
          <button className="nav-btn nav-btn-primary" onClick={onGetStarted}>Get Started</button>
        </div>
      </nav>

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg" />
        <div className="hero-tag">
          <span>🎵</span> Now Live at tapped.site
        </div>
        <h1 className="hero-title">
          Your crowd,<br /><span>your sound.</span>
        </h1>
        <p className="hero-sub">
          Tapped turns any venue into a collaborative music experience. Tap in, request songs, vote on the queue, and shape the vibe — together.
        </p>
        <div className="hero-actions">
          <button className="btn-primary" onClick={onGetStarted}>Get Started Free</button>
          <button className="btn-secondary" onClick={onGetStarted}>I'm a Venue Owner</button>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features">
        <div className="section-tag">Features</div>
        <h2 className="section-title">Everything the crowd needs</h2>
        <p className="section-sub">One tap connects your phone to the venue's music. No app download needed.</p>
        <div className="features-grid">
          {[
            { icon: "📲", title: "NFC Tap to Connect", desc: "Tap the sticker at your table. Instantly connected to the venue's live queue." },
            { icon: "🎵", title: "Request Any Song", desc: "Search Spotify's entire library and add songs to the shared queue in seconds." },
            { icon: "🔥", title: "Community Voting", desc: "Upvote the songs you want to hear. The crowd decides what plays next." },
            { icon: "💸", title: "Pay to Skip", desc: "Can't wait for your song? Pay to bump it to the top or skip what's playing." },
            { icon: "👥", title: "See Who's Here", desc: "View other Tapped users active at the venue. Make new connections on a night out." },
            { icon: "💬", title: "Message Connections", desc: "Connect with people you meet at venues and chat anywhere, anytime." },
            { icon: "⭐", title: "Rate the Vibe", desc: "React to songs in real time. Help the venue understand what the crowd loves." },
            { icon: "🎛️", title: "Venue Controls", desc: "Venue owners get full control — genre filters, blacklists, and a revenue dashboard." },
          ].map((f) => (
            <div key={f.title} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <div className="feature-title">{f.title}</div>
              <div className="feature-desc">{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="how-it-works">
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <div className="section-tag" style={{ textAlign: "center" }}>How It Works</div>
          <h2 className="section-title" style={{ textAlign: "center", maxWidth: "100%" }}>Three steps to the perfect night</h2>
          <div className="steps">
            {[
              { n: "1", title: "Tap the NFC sticker", desc: "Every Tapped venue has NFC stickers on tables, at the bar, or by the entrance. Tap your phone and you're instantly connected — no app download, no login required to browse." },
              { n: "2", title: "Create a profile or join as guest", desc: "Sign up with email, Google, or your Spotify account to unlock your full profile. Or continue as a guest to request and vote without an account." },
              { n: "3", title: "Shape the night", desc: "Search songs, vote on the queue, rate the vibe, and connect with others in the room. The crowd with the most votes wins — unless someone pays to skip." },
            ].map((s) => (
              <div key={s.n} className="step">
                <div className="step-num">{s.n}</div>
                <div>
                  <div className="step-title">{s.title}</div>
                  <div className="step-desc">{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SOCIAL */}
      <section className="social">
        <div className="section-tag">Social</div>
        <h2 className="section-title">Music brings people together</h2>
        <p className="section-sub">Your Tapped profile travels with you across every venue.</p>
        <div className="social-grid">
          <div className="social-card accent">
            <div style={{ fontSize: 32, marginBottom: 16 }}>👤</div>
            <div className="feature-title">Your Music Profile</div>
            <div className="feature-desc" style={{ marginTop: 8 }}>
              Your most requested songs, vibe ratings, and Spotify data all in one public or private profile. Show the world your taste.
            </div>
          </div>
          <div className="social-card">
            <div style={{ fontSize: 32, marginBottom: 16 }}>🤝</div>
            <div className="feature-title">Connect With Others</div>
            <div className="feature-desc" style={{ marginTop: 8 }}>
              See who's at the venue with a public profile. Send a connection request and keep in touch after the night ends.
            </div>
          </div>
          <div className="social-card">
            <div style={{ fontSize: 32, marginBottom: 16 }}>💬</div>
            <div className="feature-title">Message Requests</div>
            <div className="feature-desc" style={{ marginTop: 8 }}>
              Messages from new connections arrive as requests — so you're never bombarded. Accept the ones you want.
            </div>
          </div>
          <div className="social-card">
            <div style={{ fontSize: 32, marginBottom: 16 }}>🔒</div>
            <div className="feature-title">Full Privacy Control</div>
            <div className="feature-desc" style={{ marginTop: 8 }}>
              Choose what's public and what stays private. Your profile, your connections list, your call.
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="cta-box">
          <h2 className="cta-title">Ready to tap in?</h2>
          <p className="cta-sub">Join Tapped and start shaping the music at venues near you.</p>
          <button className="btn-primary" onClick={onGetStarted} style={{ fontSize: 17, padding: "18px 48px" }}>
            Create Your Profile
          </button>
          <div style={{ marginTop: 16, fontSize: 13, color: "rgba(255,255,255,0.3)" }}>
            Free to use · No app download required
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-logo">tapped</div>
        <div className="footer-text">© 2025 Tapped. All rights reserved.</div>
      </footer>
    </div>
  );
}
